/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ds_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online data size converter. Convert between bytes, kilobytes, megabytes, gigabytes and the binary KiB, MiB, GiB units at once. Works in your browser.`)
};

const es_ds_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de tamaño de datos en línea gratuito. Convierte entre bytes, kilobytes, megabytes, gigabytes y las unidades binarias KiB, MiB, GiB todas a la vez. Funciona en tu navegador.`)
};

const de_ds_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Datengrößen-Konverter. Rechnen Sie gleichzeitig zwischen Byte, Kilobyte, Megabyte, Gigabyte und den binären Einheiten KiB, MiB, GiB um. Funktioniert in Ihrem Browser.`)
};

const nl_ds_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online omzetter voor gegevensgrootte. Converteer tussen bytes, kilobytes, megabytes, gigabytes en de binaire KiB, MiB, GiB-eenheden tegelijk. Werkt in uw browser.`)
};

const fr_ds_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertisseur de taille de données gratuit en ligne. Convertissez entre les kilooctets, mégaoctets, gigaoctets et les unités binaires KiB, MiB, GiB en une seule fois. Fonctionne dans votre navigateur.`)
};

const it_ds_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertitore di dimensioni dei dati online gratuito. Converti tra B, KB, MB, GB e le unità binarie KiB, MiB, GiB contemporaneamente. Funziona nel tuo browser.`)
};

const pt_br2_ds_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de tamanho de dados online gratuito. Converta entre bytes, kilobytes, megabytes, gigabytes e as unidades binárias KiB, MiB, GiB de uma só vez. Funciona no seu navegador.`)
};

const pt_ds_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor gratuito online de tamanhos de dados. Converta entre bytes, quilobytes, megabytes, gigabytes e as unidades binárias KiB, MiB, GiB simultaneamente. Funciona no seu navegador.`)
};

const ja_ds_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バイト、キロバイト、メガバイト、ギガバイトおよびバイナリユニットKiB、MiB、GiBを一度に変換できる無料のオンラインデータサイズ変換ツール。ブラウザで動作します。`)
};

const zh_ds_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费在线数据大小转换器。一次性完成字节、千字节、兆字节、千兆字节与二进制 KiB、MiB、GiB 单位之间的换算。在浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ds_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ds_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ds_meta_description", locale)
	if (locale === "en") return en_ds_meta_description(inputs)
	if (locale === "es") return es_ds_meta_description(inputs)
	if (locale === "de") return de_ds_meta_description(inputs)
	if (locale === "nl") return nl_ds_meta_description(inputs)
	if (locale === "fr") return fr_ds_meta_description(inputs)
	if (locale === "it") return it_ds_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_ds_meta_description(inputs)
	if (locale === "pt") return pt_ds_meta_description(inputs)
	if (locale === "ja") return ja_ds_meta_description(inputs)
	return zh_ds_meta_description(inputs)
};